export default {
    props: {
        dto: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            required: true
        },
    },
    methods: {
        id(id) {
            return id + '-' + this.dto._uuid;
        },
    }
};
